export const categories = [
  { id: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', slug: 'dianshiju' },
  { id: 'dianying', name: '电影', icon: 'ri-film-line', slug: 'dianying' },
  { id: 'dongman', name: '动漫', icon: 'ri-emotion-line', slug: 'dongman' },
  { id: 'zongyi', name: '综艺', icon: 'ri-mic-line', slug: 'zongyi' },
  { id: 'jilupian', name: '纪录片', icon: 'ri-camera-line', slug: 'jilupian' },
  { id: 'jingsong', name: '动作片', icon: 'ri-fire-line', slug: 'jingsong' },
  { id: 'aiqing', name: '爱情片', icon: 'ri-heart-line', slug: 'aiqing' },
  { id: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line', slug: 'xiju' },
];

export const videos = [
  {
    id: 1,
    title: '长安十二时辰',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%2C%20Tang%20Dynasty%20warriors%20in%20armor%20standing%20in%20ancient%20city%20street%20at%20night%2C%20cinematic%20lighting%20with%20warm%20lantern%20glow%2C%20mysterious%20atmosphere%2C%20film%20poster%20design%2C%20dramatic%20composition&width=600&height=800&seq=video-cover-01&orientation=portrait',
    rating: 9.1,
    year: 2019,
    region: '中国大陆',
    episodes: 48,
    status: '已完结',
    description: '唐朝天宝三年，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与靖安司司丞李必携手在十二个时辰内拯救长安。',
    actors: ['雷佳音', '易烊千玺', '周一围'],
    director: '曹盾',
    isHot: true,
    isNew: false,
    updateInfo: '全48集',
  },
  {
    id: 2,
    title: '流浪地球2',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20astronauts%20in%20spacesuits%20facing%20a%20giant%20glowing%20planet%20in%20deep%20space%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20futuristic%20technology%2C%20warm%20orange%20and%20cool%20blue%20contrast&width=600&height=800&seq=video-cover-02&orientation=portrait',
    rating: 8.3,
    year: 2023,
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。面对重重危机，人类将如何延续文明？',
    actors: ['吴京', '刘德华', '李雪健'],
    director: '郭帆',
    isHot: true,
    isNew: false,
    updateInfo: '高清完整版',
  },
  {
    id: 3,
    title: '狂飙',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20two%20men%20in%20dark%20suits%20facing%20each%20other%20in%20a%20modern%20city%20at%20night%2C%20tense%20atmosphere%2C%20neon%20reflections%20on%20wet%20street%2C%20cinematic%20noir%20style%2C%20dramatic%20portrait%20photography&width=600&height=800&seq=video-cover-03&orientation=portrait',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    episodes: 39,
    status: '已完结',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开长达二十年的生死较量。',
    actors: ['张译', '张颂文', '李一桐'],
    director: '徐纪周',
    isHot: true,
    isNew: false,
    updateInfo: '全39集',
  },
  {
    id: 4,
    title: '哪吒之魔童降世',
    category: 'dongman',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20red%20sash%20flying%20through%20stormy%20clouds%2C%20vibrant%20traditional%20Chinese%20art%20style%2C%20epic%20fantasy%2C%20dynamic%20action%20pose%2C%20rich%20colors&width=600&height=800&seq=video-cover-04&orientation=portrait',
    rating: 8.4,
    year: 2019,
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    description: '天地灵气孕育出一颗混元珠，元始天尊将其炼化为灵珠和魔丸。本应是灵珠英雄的哪吒却阴差阳错成了混世大魔王。',
    actors: ['吕艳婷', '囧森瑟夫', '陈浩'],
    director: '饺子',
    isHot: false,
    isNew: true,
    updateInfo: '高清完整版',
  },
  {
    id: 5,
    title: '三体',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20drama%20poster%20with%20mysterious%20cosmic%20microwave%20background%20radiation%20pattern%2C%20three%20stars%20system%20in%20deep%20space%2C%20a%20giant%20antenna%20dish%20on%20mountain%20observatory%2C%20cold%20blue%20and%20warm%20gold%20contrast%2C%20cinematic%20atmosphere&width=600&height=800&seq=video-cover-05&orientation=portrait',
    rating: 8.1,
    year: 2023,
    region: '中国大陆',
    episodes: 30,
    status: '已完结',
    description: '纳米科学家汪淼被警官史强带入一个神秘组织"科学边界"，由此接触到三体游戏和一个关乎人类命运的惊天秘密。',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    director: '杨磊',
    isHot: true,
    isNew: false,
    updateInfo: '全30集',
  },
  {
    id: 6,
    title: '满江红',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20film%20poster%2C%20Song%20Dynasty%20soldiers%20in%20courtyard%20at%20night%20with%20red%20lanterns%2C%20suspenseful%20atmosphere%2C%20ancient%20Chinese%20architecture%2C%20narrow%20alleyways%2C%20cinematic%20lighting%2C%20dramatic%20shadows&width=600&height=800&seq=video-cover-06&orientation=portrait',
    rating: 7.4,
    year: 2023,
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵和亲兵营副统领机缘巧合被裹挟进一场巨大的阴谋之中。',
    actors: ['沈腾', '易烊千玺', '张译'],
    director: '张艺谋',
    isHot: false,
    isNew: true,
    updateInfo: '高清完整版',
  },
  {
    id: 7,
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20celebrities%20running%20outdoors%20in%20nature%20with%20green%20forest%20background%2C%20energetic%20and%20fun%20atmosphere%2C%20bright%20sunlight%2C%20cheerful%20expressions%2C%20vibrant%20colors&width=600&height=800&seq=video-cover-07&orientation=portrait',
    rating: 7.8,
    year: 2024,
    region: '中国大陆',
    episodes: 12,
    status: '更新至第8期',
    description: '本季跑男团以生态保护为主题，走进祖国大好河山，在绿水青山间展开一场又一场趣味竞技，传递环保理念。',
    actors: ['李晨', '郑恺', '沙溢'],
    director: '姚译添',
    isHot: false,
    isNew: true,
    updateInfo: '更新至第8期',
  },
  {
    id: 8,
    title: '舌尖上的中国·第四季',
    category: 'jilupian',
    cover: 'https://readdy.ai/api/search-image?query=Food%20documentary%20poster%2C%20traditional%20Chinese%20cuisine%20close-up%20with%20steaming%20hot%20dishes%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20rustic%20kitchen%20setting%2C%20appetizing%20food%20photography%2C%20rich%20textures%20and%20colors&width=600&height=800&seq=video-cover-08&orientation=portrait',
    rating: 9.3,
    year: 2024,
    region: '中国大陆',
    episodes: 8,
    status: '更新至第4集',
    description: '延续前三季的美食探索之旅，深入中国各地寻找最地道的人间至味，讲述食物背后的人情故事与文化传承。',
    actors: ['李立宏'],
    director: '陈晓卿',
    isHot: false,
    isNew: true,
    updateInfo: '更新至第4集',
  },
  {
    id: 9,
    title: '繁花',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Shanghai%20drama%20poster%2C%20elegant%20woman%20in%20cheongsam%20standing%20on%20the%20Bund%20at%20night%20with%20neon%20lights%20reflecting%20on%20Huangpu%20River%2C%201990s%20retro%20atmosphere%2C%20cinematic%20portrait%2C%20nostalgic%20and%20romantic&width=600&height=800&seq=video-cover-09&orientation=portrait',
    rating: 8.7,
    year: 2023,
    region: '中国大陆',
    episodes: 30,
    status: '已完结',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自身的打拼，跻身成为商界后起之秀。黄河路上人来人往，留下无数传奇故事。',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    director: '王家卫',
    isHot: true,
    isNew: false,
    updateInfo: '全30集',
  },
  {
    id: 10,
    title: '封神第一部',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%2520mythological%2520epic%2520film%2520poster%252C%2520ancient%2520warrior%2520king%2520on%2520horseback%2520with%2520army%2520in%2520background%252C%2520dramatic%2520sky%2520with%2520storm%2520clouds%252C%2520bronze%2520age%2520Chinese%2520aesthetic%252C%2520grand%2520scale%2520battle%2520scene%252C%25%20cinematic%2520lighting&width=600&height=800&seq=video-cover-10&orientation=portrait',
    rating: 7.8,
    year: 2023,
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    description: '商王殷寿暴虐无道，西伯侯之子姬发觉醒。昆仑仙人姜子牙携封神榜下山，一场浩大的封神之战就此拉开序幕。',
    actors: ['费翔', '李雪健', '黄渤'],
    director: '乌尔善',
    isHot: false,
    isNew: false,
    updateInfo: '高清完整版',
  },
  {
    id: 11,
    title: '唐朝诡事录之西行',
    category: 'dianshiju',
    cover: 'https://readdy.ai/api/search-image?query=Tang%20Dynasty%20mystery%20drama%20poster%2C%20two%20detectives%20in%20ancient%20Chinese%20robes%20walking%20through%20misty%20bamboo%20forest%20at%20night%2C%20mysterious%20atmosphere%2C%20lantern%20light%2C%20gothic%20Chinese%20horror%20aesthetic&width=600&height=800&seq=video-cover-11&orientation=portrait',
    rating: 8.2,
    year: 2024,
    region: '中国大陆',
    episodes: 36,
    status: '更新至第24集',
    description: '苏无名和卢凌风二人一路西行，破解沿途诡异奇案。西域风光与唐朝风韵交织，悬疑与奇幻并存。',
    actors: ['杨旭文', '杨志刚', '郜思雯'],
    director: '柏杉',
    isHot: true,
    isNew: true,
    updateInfo: '更新至第24集',
  },
  {
    id: 12,
    title: '独行月球',
    category: 'dianying',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20sci-fi%20film%20poster%2C%20a%20lone%20astronaut%20standing%20on%20the%20moon%20surface%20with%20Earth%20in%20background%2C%20humorous%20pose%2C%20starry%20space%2C%20cinematic%20lighting%2C%20warm%20and%20cool%20contrast%2C%20surreal%20atmosphere&width=600&height=800&seq=video-cover-12&orientation=portrait',
    rating: 6.8,
    year: 2022,
    region: '中国大陆',
    episodes: 1,
    status: '已上映',
    description: '人类为抵御小行星撞击，在月球部署月盾计划。陨石提前来袭，维修工独孤月被意外遗落在月球，开始了一段啼笑皆非的月球生活。',
    actors: ['沈腾', '马丽', '黄才伦'],
    director: '张吃鱼',
    isHot: false,
    isNew: false,
    updateInfo: '高清完整版',
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '长安十二时辰',
    subtitle: '年度最受欢迎古装悬疑巨制',
    description: '唐朝天宝三年，上元节前夕，长安城陷入惊天阴谋。死囚张小敬临危受命，十二时辰拯救长安。',
    bgImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20red%20lanterns%20and%20crowded%20streets%2C%20Tang%20Dynasty%20architecture%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20epic%20scale%2C%20mysterious%20atmosphere%2C%20film-like%20quality%2C%20no%20text&width=1600&height=900&seq=hero-slide-01&orientation=landscape',
    rating: 9.1,
    tag: '热播中',
    link: '/detail/1',
  },
  {
    id: 2,
    title: '繁花',
    subtitle: '王家卫首部电视剧作品',
    description: '九十年代上海，阿宝凭借改革开放春风跻身商界。黄河路上人来人往，留下无数传奇故事。',
    bgImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Bund%20at%20night%20with%20neon%20signs%20and%20vintage%20cars%2C%20nostalgic%20retro%20atmosphere%2C%20warm%20golden%20street%20lights%2C%20cinematic%20cityscape%2C%20romantic%20mood%2C%20no%20text%20or%20watermark&width=1600&height=900&seq=hero-slide-02&orientation=landscape',
    rating: 8.7,
    tag: '热播中',
    link: '/detail/9',
  },
  {
    id: 3,
    title: '三体',
    subtitle: '中国科幻里程碑之作',
    description: '纳米科学家汪淼被卷入关乎人类命运的惊天秘密，三体文明正在逼近，人类文明面临前所未有的挑战。',
    bgImage: 'https://readdy.ai/api/search-image?query=Deep%20space%20with%20three%20stars%20and%20a%20mysterious%20alien%20civilization%20signal%2C%20giant%20radio%20telescope%20on%20Earth%2C%20cosmic%20scale%2C%20sci-fi%20cinematic%20lighting%2C%20cold%20blue%20and%20warm%20orange%20contrast%2C%20epic%20atmosphere&width=1600&height=900&seq=hero-slide-03&orientation=landscape',
    rating: 8.1,
    tag: '经典回顾',
    link: '/detail/5',
  },
];

export const siteInfo = {
  name: '人人影视',
  slogan: '高清免费在线观看，不缓冲秒播极速播放',
  description: '人人影视汇聚海量免费影视资源，覆盖热门电视剧全集、电影大全、动漫、综艺、纪录片等，高清画质免付费，即点即看。致力于为影迷提供最优质的在线观看体验。',
  email: 'support@renrentv.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园',
  foundedYear: 2015,
  stats: {
    totalVideos: '50,000+',
    dailyActive: '800万',
    totalUsers: '1.2亿',
    satisfaction: '98.5%',
  },
  features: [
    {
      title: '高清画质',
      description: '全站支持1080P超清画质，部分资源支持4K，让每一帧都清晰动人。',
      icon: 'ri-4k-line',
    },
    {
      title: '秒播不缓冲',
      description: '全球CDN加速节点，极速加载，告别缓冲等待，畅享丝滑观影体验。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '海量资源',
      description: '汇聚超过五万部影视资源，涵盖电视剧、电影、动漫、综艺等全品类。',
      icon: 'ri-database-2-line',
    },
    {
      title: '完全免费',
      description: '所有资源免费观看，无需会员，无需付费，真正做到让好内容触手可及。',
      icon: 'ri-vip-crown-line',
    },
  ],
  testimonials: [
    {
      name: '小明同学',
      avatar: '',
      content: '人人影视真的太好用了！画质清晰，播放流畅，资源超级全，想看什么都能找到。强烈推荐！',
      rating: 5,
    },
    {
      name: '电影狂热者',
      avatar: '',
      content: '用了三年了，从来没有让我失望过。更新速度快，新剧上映第一时间就能看到，追剧党的福音！',
      rating: 5,
    },
    {
      name: '追剧小能手',
      avatar: '',
      content: '界面简洁干净，没有乱七八糟的广告，观影体验一级棒。已经推荐给身边所有朋友了。',
      rating: 5,
    },
    {
      name: '深夜看剧人',
      avatar: '',
      content: '不管是经典老剧还是最新热剧，画质都非常棒，而且完全不卡顿。免费又良心，必须支持！',
      rating: 5,
    },
  ],
};

export const faqs = [
  {
    question: '人人影视是否需要付费观看？',
    answer: '完全不需要！人人影视所有资源均为免费观看，我们致力于让每一位用户都能免费享受高品质影视内容。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '人人影视支持PC端、手机端、平板端全平台观看，适配各种屏幕尺寸，随时随地享受高清观影体验。',
  },
  {
    question: '为什么播放如此流畅？',
    answer: '我们采用全球CDN加速技术和先进的视频编码方案，在保证高清画质的同时实现秒播不缓冲，让观影更加丝滑顺畅。',
  },
  {
    question: '资源更新速度快吗？',
    answer: '我们的内容团队全天候跟进最新影视动态，热门剧集和电影上映后第一时间更新，让您不再错失精彩内容。',
  },
  {
    question: '画质最高支持多少？',
    answer: '全站默认支持1080P超清画质，部分精选资源支持4K超高清，给您带来影院级的视觉享受。',
  },
  {
    question: '如何搜索想看的影视？',
    answer: '您可以使用网站顶部的搜索框输入关键词搜索，也可以通过分类导航浏览不同类型的影视内容，轻松找到心仪的影片。',
  },
];